import { ArrowRight } from 'lucide-react';

import { OpenAppButton } from '@/components/ui/open-app-dialog';
import { BookDemoButton } from '@/components/ui/book-demo-dialog';
import { Container } from '@/components/ui/container';
import { Reveal } from '@/components/ui/reveal';
import { finalCta } from '@/content/site';

export function FinalCta() {
  return (
    <section className="py-20 sm:py-28 bg-surface border-t border-hairline">
      <Container>
        <Reveal>
          <div className="relative pt-6 text-center">
            <h2 className="mx-auto mt-6 text-balance text-3xl font-medium tracking-tight text-slate-900 sm:text-5xl">
              {finalCta.title}
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-pretty text-base text-ink-600 sm:text-lg">
              {finalCta.subtitle}
            </p>

            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <BookDemoButton
                variant="primary"
                size="lg"
                analyticsLocation="final_cta"
              >
                Book a demo
                <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-0.5" />
              </BookDemoButton>
              <OpenAppButton
                variant="secondary"
                size="lg"
                analyticsLocation="final_cta"
              >
                Open the app
              </OpenAppButton>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
